import * as React from "react"
import gsap from "gsap"; // <-- import GSAP
import { useGSAP } from "@gsap/react"; // <-- import the hook from our React package

import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default () => {
  useGSAP(() => {
    gsap.timeline({
      defaults: {
        duration: 1,
        ease: "RoughEase"
      },
      scrollTrigger: {
        trigger: "#icon-computer",
        start: "top center",
        end: "bottom center",
        markers: false,
        toggleActions: "play none play reset"
      }
		}).to('.hands', {
			duration: 1.5,
			rotate: 1080,
			transformOrigin: "center center",
    }).from('.numbers', {
				duration: 0.8,
				scale: 0,
				transformOrigin: "center center",
      }).to('.numbers', {
        scale: 1,
      })
    });

 return (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 107.7 99" id="icon-computer">
		<g>
			<path className="numbers" fill="#001e5d" d="M74.41 54.05H60.07v-3.02l5.15-5.21c1.52-1.56 2.52-2.64 2.99-3.25s.8-1.16 1.01-1.68c.21-.51.31-1.05.31-1.6 0-.82-.23-1.44-.68-1.84s-1.06-.6-1.82-.6-1.57.18-2.32.55-1.53.88-2.34 1.56l-2.36-2.79c1.01-.86 1.85-1.47 2.51-1.82a8.94 8.94 0 0 1 2.17-.82c.79-.19 1.66-.29 2.64-.29 1.28 0 2.41.23 3.4.7.98.47 1.74 1.12 2.29 1.96s.81 1.81.81 2.89c0 .95-.17 1.83-.5 2.66s-.85 1.68-1.54 2.55-1.92 2.11-3.68 3.72l-2.64 2.48v.2h8.94v3.65Zm16.43-4.25h-2.47v4.25h-4.24V49.8h-8.76v-3.02l8.99-13.25h4v12.89h2.47v3.37h.01Zm-6.71-3.36v-3.48c0-.58.02-1.42.07-2.53.05-1.1.08-1.74.11-1.92h-.11c-.35.77-.76 1.52-1.25 2.24l-3.76 5.68h4.94Z"/>
			<g fill="none" stroke="#001e5d" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.33">
				<path d="M60.79 79.95c0 9.61 6.23 17.39 13.91 17.39H32.96c7.68 0 13.91-7.79 13.91-17.39h13.92ZM1.66 71.24c0 4.78 3.91 8.7 8.7 8.7h86.97c4.78 0 8.7-3.91 8.7-8.7v-8.7H1.66v8.7Z"/>
				<path d="M97.33 1.68H10.35c-4.78 0-8.69 3.91-8.69 8.68v52.18h104.36V10.36c0-4.78-3.91-8.7-8.7-8.7h0ZM58.18 71.35h-8.7c-.06 0-.11-.05-.11-.11s.05-.11.11-.11h8.7c.06 0 .11.05.11.11s-.05.11-.11.11Z"/>
			</g>
			<g fill="none" stroke="#001e5d" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.33">
				<path className="hands" d="M77.62 29.55C76.35 17.55 66.19 8.2 53.86 8.2c-13.2 0-23.9 10.7-23.9 23.9S40.66 56 53.86 56"/>
				<path d="M41.79 33.8h12.59V17.05"/>
			</g>
		</g>
	</svg>
 );
}